import { render, staticRenderFns } from "./csi-competition-index.vue?vue&type=template&id=d57b2bfc&scoped=true&"
import script from "./csi-competition-index.vue?vue&type=script&setup=true&lang=js&"
export * from "./csi-competition-index.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./csi-competition-index.vue?vue&type=style&index=0&id=d57b2bfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57b2bfc",
  null
  
)

export default component.exports